import { RowActions } from 'app/components'
import { IconPaths } from '_metronic/helpers'
import { NotificacaoList } from '../../../core/_models'
import { useNotificacoes } from '../../../core/NotificacoesProvider'

export const NotificacaoActionsCell = ({ notificacao }: { notificacao: NotificacaoList }) => {
  const { marcarComoLida, abrirNotificacao } = useNotificacoes()

  return (
    <RowActions
      itemName={`notificação ${notificacao.titulo}`}
      primaryAction={{
        label: 'Ver notificação',
        onClick: () => abrirNotificacao(notificacao),
        icon: IconPaths.Search,
      }}
      items={[
        {
          label: 'Marcar como lida',
          onClick: () => marcarComoLida(notificacao.id),
          hidden: notificacao.lida,
        },
      ]}
    />
  )
}
